import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft, Download, Mail } from 'lucide-react';
import { WORKBOOK_URL } from '../lib/config';
import { trackEvent } from '../lib/analytics';

export default function Confirmation() {
    const { state } = useLocation();
    const prenom = state?.prenom;

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="flex min-h-screen flex-col bg-creme font-sans text-cacao" data-testid="confirmation-page">
            <header className="flex justify-center border-b border-champagne/40 px-6 py-6">
                <img src="/assets/phoenix.png" alt="Phénix Éclora" className="w-14 mix-blend-multiply" />
            </header>

            <main className="flex flex-1 items-center justify-center px-6 py-16">
                <motion.div
                    initial={{ opacity: 0, y: 24 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
                    className="w-full max-w-lg text-center"
                >
                    <p className="eyebrow">Reset Éclora</p>
                    {prenom && (
                        <p className="mt-6 text-serifit text-xl text-cacao/85">Merci {prenom}.</p>
                    )}
                    <h1 className="mt-4 font-script text-4xl leading-snug text-bordeaux sm:text-5xl" data-testid="confirmation-message">
                        Bienvenue dans ton Éclora 🌿
                    </h1>
                    <p className="mx-auto mt-6 max-w-md text-serifit text-xl leading-relaxed text-cacao sm:text-2xl">
                        Ton Reset arrive dans ta boîte mail dans quelques instants.
                    </p>

                    <div className="mx-auto mt-8 flex max-w-md items-center justify-center gap-3 border border-champagne/40 bg-white/60 px-5 py-4 text-left">
                        <Mail className="h-5 w-5 shrink-0 text-champagne" strokeWidth={1.5} aria-hidden="true" />
                        <p className="text-xs leading-relaxed text-cacao/75">
                            L'email part de <span className="text-bordeaux">contact@mon-eclora.fr</span> — pense à vérifier
                            tes spams ou l'onglet « Promotions » si tu ne le vois pas.
                        </p>
                    </div>

                    <a
                        href={WORKBOOK_URL}
                        download="Reset-Eclora-7-jours.pdf"
                        className="btn-bordeaux group mx-auto mt-8 sm:w-auto"
                        data-testid="confirmation-download-button"
                        onClick={() => trackEvent('workbook_download', { source: 'confirmation' })}
                    >
                        <Download className="h-4 w-4" aria-hidden="true" />
                        <span className="relative z-10">Télécharger mon Reset Éclora</span>
                        <span
                            aria-hidden="true"
                            className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/20 to-transparent transition-transform duration-700 ease-out group-hover:translate-x-full"
                        />
                    </a>
                    <p className="mt-3 text-xs text-cacao/60">Impatiemment ? Le workbook est aussi disponible ici, tout de suite.</p>

                    <p className="mt-10 font-script text-2xl text-champagne sm:text-3xl">Il n'est jamais trop tard pour éclore.</p>

                    <a
                        href="/"
                        className="mt-8 inline-flex items-center gap-2 text-xs uppercase tracking-[0.22em] text-cacao/60 transition-colors duration-300 hover:text-bordeaux"
                        data-testid="confirmation-back-link"
                    >
                        <ArrowLeft className="h-4 w-4" strokeWidth={1.5} aria-hidden="true" />
                        Retour à l'accueil
                    </a>
                </motion.div>
            </main>

            <footer className="border-t border-champagne/40 px-6 py-6 text-center">
                <p className="text-xs text-cacao/50">© 2026 Mon Éclora</p>
            </footer>
        </div>
    );
}
